import { DateTime, Settings } from "luxon";
Settings.defaultLocale = "en";

export const formatDate = (date, isTime = true) => {
  return DateTime.fromJSDate(new Date(date)).toFormat(
    `dd/MM/yyyy ${isTime === true ? "- hh:mma" : ""} `
  );
};
